<template>
	<div v-if="curProject">
		<div class="title_wrap">
			<!-- <p>三国圣地·智慧武侯</p>
			<h2>锦江区馆</h2> -->
			<img
				:src="'images/area/'+id+'/title.png'"
				alt=""
			>
		</div>
		<div class="info_wrap">
			<div class="imglist">
				<div
					class="swiper-container"
					ref="imglist"
				>
					<div
						class="swiper-wrapper"
						ref="fancybox"
					>
						<!-- Slides -->
						<div
							v-for="item in imgs"
							:key="item.key"
							class="swiper-slide"
							:href="item.src"
							:data-fancybox="'galle'+id"
						>
							<img
								:src="item.src"
								alt=""
							>
						</div>

					</div>
				</div>
				<span
					class="scale_icon"
					ref="scale_icon"
				></span>
				<div class="swiper-pagination img_pagination"></div>
			</div>
			<div class="text_wrap article_wrap">

				<p v-html="curProject.desc"></p>
			</div>
			<a
				class="zszc_btn"
				@click="showPopup"
				href="javascript:void(0)"
			> <span>点击查看招商政策</span> </a>
		</div>
		<div class="project_list">
			<h2 class="title"></h2>
			<a
				v-if="curProject.projects.length>3"
				class="arr_left"
				href="javascript:void(0)"
       
			></a>
			<a
				v-if="curProject.projects.length>3"
				class="arr_right"
				href="javascript:void(0)"
       
			></a>
			<div
				class="swiper-container"
				ref="project_list"
			>

				<div
					class="project_wrapper swiper-wrapper"
					ref="project_list_inner"
				>
					<div
						v-for="(item,key) in curProject.projects"
						class="project_item swiper-slide"
						@click="viewDetail(id+'-'+(key+1))"
						:key="key"
					>
						<p class="title">{{item.title}}</p>
						<p v-if="item.contact" class="contact">联系人：{{item.contact}}</p>
						<p v-if="item.lianxifang" class="contact">联系方：{{item.lianxifang}}</p>
						<p v-if="item.address" class="contact">建设地点：{{item.address}}</p>
						<p v-if="item.phone" class="phone">联系电话：{{item.phone}}</p>
						<p v-if="item.yusuan" class="phone">投资总额：{{item.yusuan}}</p>
						<a
							class="view_detail"
							href="javascript:void(0)"
						>查看详情</a>
					</div>
					<!-- <div
						class="project_item swiper-slide"
						@click="viewDetail(1)"
					>
						<p class="title">锦江风景区项目</p>
						<p class="contact">联系人：梁先生</p>
						<p class="phone">联系电话：18521888888</p>
						<a
							class="view_detail"
							href="javascript:void(0)"
						>查看详情</a>
					</div>
					<div
						class="project_item swiper-slide"
						@click="viewDetail(1)"
					>
						<p class="title">锦江风景区项目</p>
						<p class="contact">联系人：梁先生</p>
						<p class="phone">联系电话：18521888888</p>
						<a
							class="view_detail"
							href="javascript:void(0)"
						>查看详情</a>
					</div> -->
				</div>
			</div>
		</div>
		<div
			class="popup_wrapper"
			ref="popup_wrapper"
		>
			<div
				class="popup_outer"
				ref="popup_outer"
			></div>
			<div
				class="project_popup"
				ref="popup"
			>
				<h3 v-html="curProject.popup.title"></h3>
				<a
					class="close"
					href="javascript:void(0)"
				></a>
				<div
					class="text_wrap article_wrap"
					v-html="curProject.popup.content"
				>

				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Swiper, { Pagination, Autoplay, Navigation} from "swiper";
// configure Swiper to use modules
Swiper.use([Pagination, Autoplay,Navigation]);
// import Swiper styles
import "swiper/swiper-bundle.css";
import Popup from "ztgamejs/gpopup";
import projectApi from "../api/projects";
export default {
	data() {
		return {
			curProject: null,
			id: 0,
		};
	},
	created() {
		var id = this.$route.params.id;
		this.curProject = projectApi[id - 1];
		this.id = id;
	},
	computed: {
		imgs() {
			var imgs = [];
			for (var i = 0; i < this.curProject.img_count; i++) {
				imgs.push({
					src: "images/area/" + this.id + "/img" + (i + 1) + ".jpg",
					id: this.id + "" + i,
				});
			}
			return imgs;
		},
	},
	mounted() {
		if ($(this.$refs.imglist).find(".swiper-slide").length > 1) {
			this.myswiper = new Swiper(this.$refs.imglist, {
				loop: true,
				// allowTouchMove: false,
				autoplay: {
					delay: 3000,
				},
				pagination: {
					el: ".img_pagination",
				},
			});
		}

		$.fancybox.destroy();
		$(this.$refs.fancybox)
			.children()
			.fancybox({
				hash: false,
				buttons: ["close"],
				arrows: false,
				infobar: false,
			});
		$(this.$refs.scale_icon).click((e) => {
			var curEl = this.myswiper
				? this.myswiper.slides[this.myswiper.activeIndex]
				: $(this.$refs.imglist).find(".swiper-slide");
			//if(this.myswiper)
			// var curEl = this.myswiper.slides[this.myswiper.activeIndex];

			curEl.click();
		});

		setTimeout(() => {
			if (this.$refs.project_list_inner.childElementCount > 3) {
				this.swiper2 = new Swiper(this.$refs.project_list, {
					slidesPerView: 3,
					slidesPerGroup: 3,
					spaceBetween: 10,
					navigation: {
						nextEl: ".arr_right",
						prevEl: ".arr_left",
					},
					// allowTouchMove: false,
				});
				$(window).resize(() => {
					this.swiper2.updateSize();
				});
			} else {
				this.$refs.project_list_inner.className += " space_around";
			}
		}, 0);

		this.popup = new Popup(this.$refs.popup, {
			scrollObj: null,
			startShow: () => {
				$(this.$refs.popup_outer).show();
				$(this.$refs.popup_wrapper).css({ top: 0 });
			},
			endHide: () => {
				$(this.$refs.popup_outer).hide();
				$(this.$refs.popup_wrapper).css({ top: "-1000%" });
			},
		});
		// console.log(Popup, this.popup);
		// document.body.removeChild(this.$refs.popup);
		// document.body.appendChild(this.$refs.popup);
	},
	methods: {
		viewDetail(id) {
			this.$router.replace({
				name: "Detail",
				params: {
					id: id,
				},
			});
		},
		showPopup() {
			this.popup.show(this.$refs.popup);
		},
	},
	destroyed() {
		// var maps = document.getElementsByClassName("project_popup");
		// for (var i in maps) {
		// 	//
		// 	if (typeof maps[i] == "object") {
		// 		console.log(maps[i]);
		// 		document.body.removeChild(maps[i]);
		// 	}
		// }
	},
};
</script>
<style scoped lang="less">
.title_wrap {
	color: #fff;
	position: relative;
	width: 100%;
	margin-top: 0.4rem;
	z-index: 10;
	line-height: 1.2;
	height: 1.23rem;
	text-align: center;
	img {
		height: 100%;
	}
	p {
		font-size: 0.32rem;
		text-shadow: 0px 0px 5px #056ee1;
	}
	h2 {
		font-size: 0.76rem;
		text-shadow: 0px 0px 5px #056ee1;
	}
}
.info_wrap {
	max-width: 95%;
	margin: 0 auto;
	margin-top: -0.3rem;
	width: 13.26rem;
	height: 3.59rem;
	background: url("../assets/project_info_bg.png") no-repeat center/100% 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	.swiper-pagination {
		bottom: -0.2rem;
		width: 100%;
		text-align: center;
		& /deep/ .swiper-pagination-bullet {
			width: 0.08rem;
			height: 0.08rem;
			opacity: 1;
			background-color: #31ccff;
			margin: 0 0.1rem;
		}
		& /deep/ .swiper-pagination-bullet-active {
			background-color: #d1feff;
		}
	}
	.imglist {
		margin-top: -0.3rem;
		position: relative;
		margin-left: 0.2rem;
		width: 3.23rem;
		height: 2.05rem;
		padding: 0.12rem;
		box-sizing: border-box;
		background: url("../assets/project_swiper_bg.png") no-repeat
			center/contain;
		.scale_icon {
			display: inline-block;
			width: 1rem;
			height: 1rem;
			background: url("../assets/scale_icon.png") no-repeat center/contain;
			position: absolute;
			left: 50%;
			top: 50%;
			margin-left: -0.5rem;
			margin-top: -0.3rem;
			z-index: 100;
			animation: huxi2 0.6s ease-in-out 0s infinite alternate-reverse both;
		}
		.swiper-container {
			width: 3rem;
			height: 1.87rem;
		}

		.swiper-slide {
			width: 100%;
			height: 100%;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
	}
	.text_wrap {
		margin-top: -0.2rem;
		flex-shrink: 1;
		flex-grow: 1;
		// font-size: 0.18rem;
		color: #00c0ff;
		// line-height: 1.5;
		box-sizing: border-box;
		width: 9.1rem;
		height: 1.8rem;
		overflow: auto;
		padding-right: 0.4rem;
		margin-left: 0.2rem;
		text-align: left;
		-webkit-overflow-scrolling: touch;
	}

	.zszc_btn {
		position: absolute;
		width: 2.84rem;
		height: 0.47rem;
		line-height: 0.47rem;
		bottom: 0.2rem;
		left: 50%;
		margin-left: -1.3rem;
		display: block;
		text-align: center;

		span {
			vertical-align: middle;
		}
		&::before {
			margin-top: -0.05rem;
			content: "";
			display: inline-block;
			width: 0.43rem;
			height: 0.51rem;
			background: url("../assets/arrow_right.png") no-repeat
				center/contain;
			font-size: 0.18rem;
			color: #fff;
			vertical-align: middle;
			animation: moveright 1s ease-in 0s infinite alternate-reverse both;
		}
	}
}
.project_list {
	max-width: 90%;
	width: 12.7rem;
	margin: 0 auto;
	text-align: center;
	& > .title {
		height: 0.37rem;
		background: url("../assets/zsxm.png") no-repeat center/contain;
	}
	.project_wrapper {
	}
	.space_around {
		justify-content: space-around;
	}
	.swiper-container {
		margin-top: 0.3rem;
	}
	position: relative;
	.arr_left,
	.arr_right {
		display: inline-block;
		width: 0.4rem;
		height: 0.4rem;
		position: absolute;
		top: 58%;
		// margin-top: -0.16rem;
		z-index: 10;
  }
  .swiper-button-disabled{
    opacity: 0.5;
  }
	.arr_left {
		left: -0.4rem;
		background: url("../assets/arrleft.png") no-repeat center/contain;
	}
	.arr_right {
		right: -0.4rem;
		background: url("../assets/arrright.png") no-repeat center/contain;
	}
	.project_item {
		// max-width: 30%;
		margin-right: 1.3%;
		width: 32%;
		height: 1.16rem;
		background: url("../assets/project_bg.png") no-repeat center/100% 100%;
		text-align: left;
		box-sizing: border-box;
		padding: 0.23rem;
		padding-left: 0.5rem;
		position: relative;
		line-height: 1.4;
		.title {
			color: #00ffff;
			position: relative;
			white-space: nowrap;
			overflow: hidden;
			width: 70%;
			text-overflow: ellipsis;
			&::before {
				position: absolute;
				left: -0.2rem;
				top: 50%;
				margin-top: -0.035rem;
				content: "";
				vertical-align: middle;
				display: inline-block;
				width: 0.07rem;
				height: 0.07rem;
				display: inline-block;
				background: #00ffff;
				margin-right: 0.1rem;
			}
		}
		.contact,
		.phone {
			color: #44bfff;
			font-size: 0.16rem;
		}
		.view_detail {
			display: block;
			width: 0.72rem;
			height: 0.48rem;
			top: 50%;
			margin-top: -0.24rem;
			color: #fff;
			font-size: 0.14rem;
			white-space: nowrap;
			position: absolute;
			right: 0.3rem;
			top: 50%;
			margin-top: -0.24rem;
			right: 0.26rem;
			text-align: center;
			&::after {
				content: "";
				display: block;
				width: 0.5rem;
				height: 0.5rem;
				background: url("../assets/arrow_down.png") no-repeat
					center/contain;
				margin: -0.15rem auto 0;
				animation: movedown 1s ease-in 0s infinite alternate-reverse
					both;
			}
		}
	}
}
</style>
<style lang="less" scoped>
.popup_wrapper {
	transform: translateZ(10px);
	position: absolute;
	left: 0;
	top: -1000%;
	width: 100%;
	height: 100%;
	z-index: 1000;
}
.popup_outer {
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.9);
	position: absolute;
	left: 0;
	top: 0;
	z-index: 2000;
	display: none;
}
.project_popup {
	display: none;
	position: relative;
	width: 9.75rem;
	height: 5.96rem;
	background: url("../assets/popup_bg.png") no-repeat center/contain;
	overflow: visible;
  box-sizing: border-box;
  padding-top: 0.4rem;
	& > h3 {
		text-align: center;
		font-size: 0.4rem;
		position: absolute;
		text-shadow: 0px 0px 5px #056ee1;
    // margin-top: -0.1rem;
    width: 100%;
    bottom: 91%;
    line-height: 1.2;
	}
	.close {
		position: absolute;
		right: 0rem;
		top: 0.1rem;
		width: 0.6rem;
		height: 0.6rem;
	}
	& > .text_wrap {
		text-align: left;
		-webkit-overflow-scrolling: touch;
		width: 8.1rem;
		height: 3.66rem;
		margin: 0.8rem auto 0;
		line-height: 1.6;
		overflow: auto;
		// padding-left: 0.2rem;
		// & > h4 {
		// 	position: relative;
		// 	margin: 0.2rem 0;
		// 	font-size: 0.16rem;
		// 	&::before {
		// 		content: "";
		// 		display: inline-block;
		// 		width: 0.05rem;
		// 		height: 0.05rem;
		// 		background: #00e7ff;
		// 		border-radius: 0.025rem;
		// 		position: absolute;
		// 		left: -0.2rem;
		// 		top: 50%;
		// 		margin-top: -0.025rem;
		// 	}
		// }
		// & > p {
		// 	color: #1273ca;
		// 	font-size: 0.14rem;
		// }
	}
}
</style>